import { Link } from "zudoku/router";

/**
 * The 404 page, with the ways back into the docs. Styled by `sp-not-found` in `src/theme.ts`.
 */
export function NotFoundPage() {
  return (
    <div data-spectate-not-found="true" className="sp-not-found">
      <p className="sp-eyebrow">404 · Not found</p>
      <h1>This page does not exist</h1>
      <p>The page was moved or removed. Search the docs, or start from one of these pages.</p>
      <ul>
        <li>
          <Link to="/introduction">Introduction</Link>
        </li>
        <li>
          <Link to="/quickstart">Quickstart</Link>
        </li>
        <li>
          <Link to="/api-reference">API reference</Link>
        </li>
      </ul>
    </div>
  );
}
